import React, { useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import classNames from 'classnames'
import { toast, ToastContainer } from 'react-toastify'; // Import Toastify
import 'react-toastify/dist/ReactToastify.css';

// components
import NioIcon from '../../../NioIcon/NioIcon';
import NioField from '../../../NioField/NioField';
import NioCard from '../../../Cards/NioCard/NioCard';
import NioButton from '../../../NioButton/NioButton';
import NioToast from '../../../NioToaster/NioToaster';

import BASE_URL from '../../../../utils/apiConfig';

export default function ContactForm() {
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [authToken, setAuthToken] = useState(null);
  const [showToast, setShowToast] = useState(false);

  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    mode: 'onChange',
    defaultValues: { 
      fname: '',
      messages: '',
      phone: '',
      email: '',
    }
  });

  const authenticateUser = async () => {
    try {
        const response = await fetch(`${BASE_URL}/api/api_login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: 'api@gmail.com',
                password: '123',
            }),
        });

        const data = await response.json();
        if (response.ok) {
            return data.access_token; // Return token directly
        } else {
            console.error('Authentication failed:', data.message);
            return null;
        }
    } catch (error) {
        console.error('Error during authentication:', error);
        return null;
    }
  };

  const onSubmit = async (formData) => {
    setIsSubmitting(true);
    const token = await authenticateUser();
    if (!token) {
      setIsSubmitting(false); // Enable button if authentication fails
      return; // Stop if authentication fails
    }

    try {
        const response = await fetch(`${BASE_URL}/api/inquiries`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`, // Use token directly
            },
            body: JSON.stringify(formData),
        });

        const data = await response.json();
        if (response.ok) {
          toast.success('Successfully Sent the Message, ZiloChat Team will Contact You Soon!', { autoClose: 3000 });
          reset();
          // setTimeout(() => navigate('/'), 3000); // Navigate after 3 seconds
        } else {
          // toast.error(`Failed: ${data.errors ? data.errors[0] : 'Unknown error'}`, { autoClose: 5000 });
          if (data.errors) {
              const errorMessages = Object.values(data.errors).flat().join(', ');
              toast.error(`Failed: ${errorMessages}`, { autoClose: 5000 });
          } else {
              toast.error(`Failed: ${data.message || 'Unknown error'}`, { autoClose: 5000 });
          }
        } 
    } catch (error) {
      toast.error('An error occurred while creating the message.', { autoClose: 5000 });
      console.error('Error during saving message data:', error);
    } finally {
      setIsSubmitting(false); // Enable button once request completes (success or error)
    }
};
//   const onSubmit = (data, e) => {
//     // Prevent default form submission behavior
//     e.preventDefault();

//     // Check if there are errors in the form
//     if (Object.keys(errors).length === 0) {
//         // Show the toaster
//         setShowToast(true);

//         // Perform any other actions related to form submission
        
//         // Clear the form fields after a delay
//         setTimeout(() => {
//             reset(); // This will clear the form fields
//             setShowToast(false); // Hide the toaster
//         }, 3000); // Adjust the delay time as needed
//     }
// };


  // Classes 
  const fieldWrapper = classNames({
    "form-control-wrap": true
  });

  return (
    <>
      <NioCard className="rounded-2">
        <NioCard.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="g-4 g-lg-5">
              <Col xs="12">
                <NioField>
                  <NioField.Label label="Full Name" htmlFor="fname"  />
                  <NioField.Input id="fname" placeholder="Enter Your Name"
                   isInvalid={!!errors.fname} {...register("fname", {required: 'Full Name is Required'})}  />
                  {
                    errors?.fname && 
                    <Form.Control.Feedback type="invalid" tooltip>{errors?.fname.message}</Form.Control.Feedback>
                    }
                </NioField>
              </Col>
              <Col lg="6">
                <NioField>
                  <NioField.Label label="Email" htmlFor="email" />
                  <NioField.Input type="email" id="email" placeholder="Enter Your Email" isInvalid={!!errors.email}   {...register("email", {                        
                        pattern: {
                          value: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                          message: "Invalid Email Address"
                        }
                      })} />
                  {
                    errors?.email && 
                    <Form.Control.Feedback type="invalid" tooltip>{errors?.email.message}</Form.Control.Feedback>
                    }
                </NioField>
              </Col>
              <Col lg="6">
                <NioField>
                  <NioField.Label label="Phone" htmlFor="phone" />
                  <NioField.Input type="number" id="phone" placeholder="(077) 5555 888" isInvalid={!!errors.phone} {...register("phone", {
                    required: 'Phone is required'
                  })} />
                  {
                    errors?.phone && 
                    <Form.Control.Feedback type="invalid" tooltip>{errors?.phone.message}</Form.Control.Feedback>
                  }
                </NioField>
              </Col>
              <Col xs="12">
                <div className="form-group">
                  <div className="form-label-group">
                    <label className="form-label">Tell us a bit about your query</label>
                  </div>
                  <div className={fieldWrapper}>
                    <Form.Control 
                      rows="6"
                      as="textarea"
                      isInvalid={!!errors.messages}
                      {...register("messages", {required: 'Message is Required'})}
                      placeholder="Enter your message"
                    />
                  {
                    errors?.message && 
                    <Form.Control.Feedback type="invalid" tooltip>{errors?.messages.message}</Form.Control.Feedback>
                    }
                  </div>
                </div>
              </Col>
              <Col xs="12">
                <div className="form-group">
                  <NioButton type="submit"  className="btn-primary"  label={isSubmitting ? "Submitting..." : "Send Message"} disabled={isSubmitting}/>
                </div>
              </Col>
            </Row>
          </Form>
          <NioToast show={showToast} setShow={setShowToast} variant="success">
              <div>
                <span className="nl-toast-icon">
                  <NioIcon name="check" />
                </span>
              </div>
              <div className="nl-toast-info w-100 text-start">
                <h6 className="fs-7 mb-0">Message Sended</h6>
                <p className="fs-9">Thank You, We Will Contact With You Soon.</p>
              </div>
        </NioToast>
        </NioCard.Body>
      </NioCard>
      <ToastContainer position="bottom-left"/>
    </>
  )
}
